<template>
  <div v-bind="$attrs">
    <component
      :is="componentType"
      v-model="value"
      :size="size"
      :indeterminate="indeterminate"
      color="success"
    />
  </div>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import type { ProgressType } from "@/types/SoProgress"
  import { VProgressCircular, VProgressLinear } from "vuetify/components"

  export default defineComponent({
    components: {
      VProgressCircular,
      VProgressLinear,
    },
    inheritAttrs: false,
    props: {
      modelValue: {
        type: Number,
        default: 0,
      },
      type: {
        type: String as PropType<ProgressType>,
        default: "circular",
      },
      indeterminate: {
        type: Boolean,
        default: false,
      },
      size: {
        type: Number,
        default: 32,
      },
    },
    emits: ["update:modelValue"],

    computed: {
      value: {
        get() {
          return this.modelValue
        },
        set(value: number) {
          this.$emit("update:modelValue", value)
        },
      },
      componentType() {
        if (this.type === "linear") {
          return "v-progress-linear"
        }
        return "v-progress-circular"
      },
    },
  })
</script>
